import { useQuery } from "@tanstack/react-query";
import { getNeighbourhoodSuggestions } from "../../apis/search";

export function useNeighborhoodSuggestions() {
    return useQuery({
    queryKey: ["neighbourhoodSuggestions"],
    queryFn: () => getNeighbourhoodSuggestions(),
  });
}
